const hasMissingChildValue = (prevChildren, nextChildren) => {
    if (prevChildren.length !== nextChildren.length)
        return true;
    return prevChildren.some((child) => {
        const nextChildWithValue = nextChildren.find((nextChild) => nextChild.props.value === child.props.value);
        return !nextChildWithValue;
    });
};
export default hasMissingChildValue;
//# sourceMappingURL=hasMissingChildValue.js.map